module.exports = __webpack_public_path__ + "static/media/fullsize.994a0d92.png";